<template>
  <div class="body-container" v-if="documentData">
    <div class="body-container-header" @click="handleBack">返回报告首页</div>
    <div class="body-container-content">
      <div class="bodily-container">
        <div class="bodily">
          <div class="module-title">
            体型评估
          </div>
          <div class="qjc-fts-28 qjc-c-dark qjc-pa-l">
            体型是影响健康的重要系数之一。不健康的生活方式会直接影响体型，同时带来健康风险。
          </div>
          <div class="bodily_cell">
            <div class="bodily_item">
              <img class="experience_img" :src="`${imgHost}/activity/experience_BFR.png`" />
              <div class="qjc-fts-28 qjc-c-dark">
                体脂率
                <p class="qjc-c-primary qjc-ftw-b">
                  {{
                    ['1', '4', '7'].includes(documentData.m05.body_g[0])
                      ? '偏低'
                      : ['2', '5', '8'].includes(documentData.m05.body_g[0])
                        ? '适中'
                        : ['3', '6', '9'].includes(documentData.m05.body_g[0])
                          ? '偏高'
                          : '未知'
                  }}
                </p>
              </div>
            </div>
            <div class="bodily_item">
              <img class="experience_img" :src="`${imgHost}/activity/experience_BMI.png`" />
              <div class="qjc-fts-28 qjc-c-dark">
                BMI
                <p class="qjc-c-primary qjc-ftw-b">
                  {{ documentData.m05.bmi_g[1] }}
                </p>
              </div>
            </div>
          </div>
          <div class="group">
            <div class="qjc-fts-24">
              在同类族群中属于
              <i class="el-icon-warning-outline icon-small" color="#C9C9C9" :size="12" @click="handleGroupTips"></i>
              <div v-if="isShow" class="qjc-fts-24 qjc-absolute qjc-c-fff center">
                同族群（PLM，People Like Me）:与您相似的人群--与您同性别同年龄段的人群
              </div>
            </div>
            <div class="qjc-ftw-b qjc-c-primary qjc-fts-36 group_val">
              {{ documentData.m05.body_g[1] }}
            </div>
          </div>
          <div class="group_tips mt-5">
            {{ documentData.m05.body_g[2] }}
          </div>
        </div>

        <div class="bodily-improve">
          <div class="module-title">
            体重及体型改善方案（12周）
          </div>
          <div class="qjc-fts-28 qjc-c-dark qjc-pa-l">
            每个人都有适合自己的最佳体型，过胖或过瘦都不好，请注意体型的改善和维持。
          </div>
          <div class="improve_cell">
            <img class="experience_img" :src="`${imgHost}/activity/experience_weight.png`" />
            <div class="improve_box">
              <div class="qjc-fts-24 qjc-fl improve_box_left">
                <div class="improve_box_title">
                  当前体重
                </div>
                <div class="qjc-ftw-b c-red">
                  <p class="fonts-40">
                    {{ documentData.m12.sugweight[0] }}
                  </p>
                  kg
                </div>
              </div>
              <div class="qjc-fts-24 qjc-fr improve_box_right">
                <div class="improve_box_title">
                  建议体重
                </div>
                <div class="qjc-c-primary qjc-ftw-b">
                  <p class="fonts-40">
                    {{ documentData.m12.sugweight[1] }}
                  </p>
                  kg
                </div>
              </div>
            </div>
          </div>
          <div class="improve_cell">
            <img class="experience_img" :src="`${imgHost}/activity/experience_WHR.png`" />
            <div class="improve_box">
              <div class="qjc-fl qjc-fts-24 improve_box_left">
                <div class="improve_box_title">
                  当前腰臀比
                </div>
                <div class="qjc-ftw-b c-red">
                  <p class="fonts-40">
                    {{ documentData.m12.sugwhr[0] }}
                  </p>
                </div>
              </div>
              <div class="qjc-fr qjc-fts-24 improve_box_right">
                <div class="improve_box_title">
                  建议腰臀比
                </div>
                <div class="qjc-c-primary qjc-ftw-b">
                  <p class="fonts-40">
                    {{ documentData.m12.sugwhr[1] }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { getReportDetail } from '@/utils/axios';
import { imgHost2, imgHost } from '@/config';


export default {
  name: 'HaleonBackDetailBody',

  data () {
    return {
      documentData: null,
      imgHost2, imgHost,
      isShow: false
    };
  },

  mounted () {
    const id = this.$route.query.id;
    console.log("detail page id: ", id);
    if (id) {
      this.getDetail(id);
    }
  },

  methods: {
    getDetail (id) {
      getReportDetail({ id }).then(res => {
        if (res.code === 200) {
          const data = JSON.parse(window.atob(res.data));
          console.log(data);
          this.documentData = data;
        } else {
          console.log(res.msg);
        }
      })
    },
    handleBack () {
      this.$router.back();
    },
    handleGroupTips () {
      this.isShow = !this.isShow
    }
  },
};
</script>

<style lang="scss" scoped>
.body-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto auto 1fr;
  overflow: hidden;
  gap: 10px;
  padding: 10px;
  background-color: #F2F4FA;

  >div {
    position: relative;
    width: 100%;
    height: 100%;
  }

  &-header {
    background-color: #e2e2e2;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: bold;
    user-select: none;
    cursor: pointer;
    color: #000;
  }

  &-content {
    .bodily-container {
      position: relative;
      width: 100%;
      padding-bottom: 10px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr;
      gap: 10px;

      >div {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #fff;
      }



      .bodily {
        position: relative;
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;
      }

      .module-title {
        position: relative;
        font-size: 18px;
        font-weight: 600;
        color: #40444d;
        text-align: left;
        margin-bottom: 14px;
      }

      .module-title::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 97px;
        height: 8px;
        background: linear-gradient(90deg, #6681fa, rgba(102, 129, 250, 0));
        border-radius: 4px 4px 0 0;
      }

      .experience_img {
        width: 56px;
        height: 56px;
      }

      .qjc-fts-28 {
        font-size: 14px;
      }

      .qjc-c-dark {
        color: #000000;
      }

      .qjc-pa-l {
        font-weight: 400;
        line-height: 22px;
      }

      .bodily_cell {
        width: 100%;
        display: flex;
        align-items: center;
      }

      .bodily_item {
        flex: 1;
        text-align: center;
        margin-top: 23px;
      }

      .qjc-c-primary {
        color: #6681fa;
      }

      .qjc-ftw-b {
        font-weight: 500;
      }

      .bodily .group {
        width: 100%;
        line-height: 22px;
        color: #6a7180;
        background-color: #f5f8fc;
        padding: 12px 0;
        border-radius: 4px;
        margin-top: 23px;
        position: relative;
      }

      .qjc-fts-24 {
        font-size: 12px;
        text-align: center;
      }

      .qjc-fts-36 {
        font-size: 18px;
      }

      .group_val {
        text-align: center;
      }

      .bodily .center {
        position: absolute;
        top: 6%;
        left: 71px;
        width: 264px;
        text-align: left;
        border-radius: 4px;
        padding: 9px 12px;
        line-height: 18px;
        background-color: rgba(38, 40, 52, 0.6);
        transform: translateY(-100%);
        box-shadow: 0 3px 6px 0 #dadce3;
        opacity: 1;
        transition: all 1s;
        z-index: 100;
        color: #fff;
      }

      .bodily .center::after {
        position: absolute;
        bottom: 0;
        /* left: 40rpx; */
        left: 154px;
        content: '';
        display: block;
        width: 15px;
        height: 15px;
        background-color: #7d7e85;
        transform: rotate(45deg) translateY(50%);
        z-index: 30;
      }

      .bodily-improve {
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;
      }

      .improve_cell {
        text-align: center;
        margin-bottom: 32px;
      }

      .improve_cell image {
        margin: 20px 0 20px;
      }

      .improve_box {
        width: 100%;
        background-color: #f5f8fc;
        border-radius: 4px;
        padding: 12px 0;
        display: flex;
        align-items: center;
      }

      .improve_box_left {
        flex: 1;
        position: relative;
      }

      .improve_box_left::after {
        content: '';
        position: absolute;
        top: 6px;
        right: 0;
        bottom: 6px;
        width: 1px;
        background-color: #9ea5c9;
      }

      .improve_box_title {
        color: #777f8f;
      }

      .improve_box_right {
        flex: 1;
      }

      .c-red {
        color: #fa7893;
      }

      .improve_box p {
        font-size: 20px;
      }
    }
  }
}
</style>